// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DislikeFilledSvg from "@fishx/icons-svg/es/asn/DislikeFilled";
import FishxIcon from '../components/FishxIcon';

var DislikeFilled = function DislikeFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DislikeFilledSvg
  }));
};

DislikeFilled.displayName = 'DislikeFilled';
export default React.forwardRef(DislikeFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DislikeFilled.js
// module id = 2432
// module chunks = 0